'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Widgets.Combobox'];
module.exports = angular.module('AVRO.Sandbox.ComboboxExample', dependencies).controller('ComboboxExampleController', require('./controllers/ComboboxExampleController')).directive('rmComboboxExample', require('./directives/ComboboxExampleDirective'));